import { auth } from "../firebase";

// Tap-to-contact links and relative times for the inbox and follow-ups. The
// owner works from a phone, so "call" and "text" should open the dialer and
// Messages directly rather than copying a number around.

function digits(phone) {
  return String(phone || "").replace(/[^\d+]/g, "");
}

export function telHref(phone) {
  const d = digits(phone);
  return d ? `tel:${d}` : "";
}

export function smsHref(phone, body = "") {
  const d = digits(phone);
  if (!d) return "";
  // iOS and Android both accept "?&body=" — the stray "&" keeps iOS happy.
  return body ? `sms:${d}?&body=${encodeURIComponent(body)}` : `sms:${d}`;
}

export function mailtoHref(email, subject = "", body = "") {
  if (!email) return "";
  const params = new URLSearchParams();
  if (subject) params.set("subject", subject);
  if (body) params.set("body", body);
  const qs = params.toString().replace(/\+/g, "%20");
  return `mailto:${email}${qs ? `?${qs}` : ""}`;
}


/** The signed-in owner's first name, for "it's Tyler from Birdie Bus". */
export function senderName() {
  const n = auth.currentUser?.displayName || "";
  return n.trim().split(/\s+/)[0] || "";
}

export function firstName(name) {
  return String(name || "").trim().split(/\s+/)[0] || "there";
}

/** "just now", "3h ago", "2d ago", then a date. */
export function timeAgo(value, nowMs = Date.now()) {
  if (!value) return "";
  const t = new Date(value).getTime();
  if (Number.isNaN(t)) return "";
  const mins = Math.round((nowMs - t) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  if (days < 14) return `${days}d ago`;
  return new Date(t).toLocaleDateString([], { month: "short", day: "numeric" });
}

/** "Opened 3× · last 2h ago" / "Not opened yet" for a sent quote, else null. */
export function viewSummary(job, nowMs = Date.now()) {
  const n = Number(job.view_count || 0);
  if (n > 0) return `Opened ${n}× · last ${timeAgo(job.last_viewed_at, nowMs)}`;
  if (job.views_tracked && job.status === "sent") return "Not opened yet";
  return null;
}

/** Whole days between `value` and now (0 = today). */
export function daysSince(value, nowMs = Date.now()) {
  if (!value) return null;
  const t = new Date(value).getTime();
  if (Number.isNaN(t)) return null;
  return Math.floor((nowMs - t) / 86400000);
}
